import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PartsAppointmentComponent } from './parts-appointment.component';
import { ConfirmInfoComponentParts } from './confirm-info/confirm-info.component';
import { DeactivateGuard } from '../../shared/guards/candeactivate';

const routes: Routes = [
  {
      path: '',
      component: PartsAppointmentComponent,
      canDeactivate:[DeactivateGuard]
  },
  {
    path: 'confirm',
    component: ConfirmInfoComponentParts
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartsAppointmentRoutingModule { }
